import { is } from 'bpmn-js/lib/util/ModelUtil';
// eslint-disable-next-line
// @ts-ignore 
import { TextFieldEntry, isTextFieldEntryEdited } from '@bpmn-io/properties-panel';
// eslint-disable-next-line
// @ts-ignore
import { ModdleElement } from 'bpmn-moddle';

interface CustomModdleElement extends ModdleElement {
    customProperty?: string;
}

export default class CustomPropertiesProvider {
    private readonly translate: (str: string) => string;

    static $inject = ['propertiesPanel', 'translate'];

    constructor(propertiesPanel: any, translate: (str: string) => string) {
        this.translate = translate;
    }

    getGroups(element: ModdleElement): (groups: any[]) => any[] {
        return (groups: any[]): any[] => {
            // Handle timer events
            if (is(element, 'bpmn:TimerEventDefinition')) {
                // Ensure the businessObject has the required methods
                if (!element.get) {
                    // Add a get method if it doesn't exist
                    element.get = function (key: string) {
                        return this[key];
                    };
                }
            }

            if (is(element, 'bpmn:Process') || is(element, 'bpmn:Participant')) {
                groups.push(this.createGeneralGroup(element));
            }
            return groups;
        };
    }

    private createGeneralGroup(element: ModdleElement): any {
        const generalGroup = {
            id: 'general',
            label: this.translate('General'),
            entries: []
        };

        // eslint-disable-next-line
        // @ts-ignore 
        generalGroup.entries.push({
            id: 'customProperty',
            element,
            component: TextFieldEntry,
            isEdited: isTextFieldEntryEdited,
            get: function (this: { element: CustomModdleElement }) {
                return { value: this.element.customProperty || '' };
            },
            set: function (this: { element: CustomModdleElement }, value: string) {
                this.element.customProperty = value;
            },
            validate: (value: string) => {
                // Add any validation logic here
                return null;
            }
        } as TextFieldEntry);

        return generalGroup;
    }
}